import {
  GET_INFO_CONTACTENOS,
  EDITAR_CONTACTENOS
} from "../../types";

export default (state, action) => {
  switch (action.type) {
    case GET_INFO_CONTACTENOS:
      return {
        ...state,
        banner: action.payload.banner,
        section1: action.payload.section1
      };
    case EDITAR_CONTACTENOS:
      return {
        ...state,
        banner: JSON.parse(action.payload.banner),
        section1: JSON.parse(action.payload.section1),
      };
    default:
      return state;
  }
};
